import * as TooltipPrimitives from "@radix-ui/react-tooltip";
import React from "react";

import BalanceDetails from "../BalanceDetails";
import CurrentBalance from "../CurrentBalance";
import type { ApplicationBalanceModel } from "./model";

export interface ApplicationBalanceProps {
  model: ApplicationBalanceModel;
  onActivate: () => void;
  className?: string;
}

export const ApplicationBalance: React.FC<ApplicationBalanceProps> = ({
  model,
  onActivate,
  className,
}) => {
  const balance = (
    <CurrentBalance
      amount={model.amount}
      label={model.label}
      isLoading={model.isDataLoading}
      isStatusLoading={model.isStatusLoading}
      statusTone={model.tone}
      valueTone={
        model.isDanger ? "danger" : model.isCallToAction ? "cta" : "default"
      }
      onActivate={onActivate}
      className={className}
    />
  );

  if (!model.showDetails) return balance;

  return (
    <TooltipPrimitives.Provider>
      <TooltipPrimitives.Root delayDuration={0}>
        <TooltipPrimitives.Trigger asChild>{balance}</TooltipPrimitives.Trigger>
        <TooltipPrimitives.Portal>
          <TooltipPrimitives.Content
            side="bottom"
            align="end"
            sideOffset={6}
            className="z-50 rounded-md border border-zinc-700 bg-zinc-900 px-3 py-2.5 shadow-xl"
          >
            <BalanceDetails model={model} />
            <TooltipPrimitives.Arrow className="fill-zinc-700" />
          </TooltipPrimitives.Content>
        </TooltipPrimitives.Portal>
      </TooltipPrimitives.Root>
    </TooltipPrimitives.Provider>
  );
};

ApplicationBalance.displayName = "ApplicationBalance";

export default ApplicationBalance;
